



























































































import Vue from 'vue';
import { Route } from 'vue-router';
import { Action, Mutation, State } from 'vuex-class';
import { Component, Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import store from '@/store';
import { Block } from '@/types/block';
import { codemirror } from 'vue-codemirror-lite';
import Editor from '@/components/Editor/Editor.vue';
import PageMetaDataInput from '@/components/Page/PageMetaDataInput.vue';
require('codemirror/mode/htmlmixed/htmlmixed');
require('codemirror/addon/edit/closetag');
require('codemirror/addon/edit/matchtags');

@Component({
  components: {
    codemirror,
    Editor,
    PageMetaDataInput,
  },
})
export default class BlockEditor extends Vue {
  @Prop() id!: string;
  @Action('blockEditor/saveBlock') saveBlock!: Function;
  @Action('notifications/addNotification') addNotification!: Function;
  @Mutation('blockEditor/setBlockTitle') setBlockTitle!: Function;
  @Mutation('blockEditor/setBlockContent') setBlockContent!: Function;
  @Mutation('blockEditor/setBlockSlug') setBlockSlug!: Function;
  @Mutation('blockEditor/setBlockDescription') setBlockDescription!: Function;
  @State('blockEditor') block!: Block;

  slug: string | null | undefined = null;
  dialog: boolean = false;
  isSaving: boolean = false;
  isDirty: boolean = false;
  tabs: number = 0;
  toggleEditMode: number = 0;
  codemirrorOptions: object = {
    mode: 'htmlmixed',
    tabSize: 4,
    lineNumbers: true,
    lineWrapping: true,
    matchTags: true,
    closeTag: true,
    viewportMargin: Infinity,
  };

  validation: object = {
    title: [(v: any) => !!v || 'A title is required'],
    slug: [(v: any) => !!v || 'A slug is required'],
    description: [(v: any) => !!v || 'A description is required'],
  };

  isEditorValid: boolean = true;

  userHasAlteredSlug: boolean = false;

  get titleProgress(): number {
    return Math.min(100, Math.floor(this.blockTitle.length * 0.6));
  }

  get titleColour(): string {
    if (this.blockTitle.length > 100) {
      return 'error';
    }
    const index = Math.min(2, Math.floor(this.blockTitle.length / 30));
    return ['error', 'warning', 'success'][index];
  }

  get editorContent(): string {
    return this.block.content as string;
  }

  get blockTitle(): string {
    return this.block.title || '';
  }
  set blockTitle(value) {
    if (this.block.slug === '' || !this.userHasAlteredSlug) {
      this.block.slug = _.kebabCase(value);
    }
    this.setBlockTitle(value);
  }

  get blockContent(): string | undefined | null {
    return this.block.content;
  }
  set blockContent(value) {
    this.setBlockContent(value);
  }

  get blockSlug(): string | null | undefined {
    return this.block.slug;
  }
  set blockSlug(slug: string | null | undefined) {
    this.block.slug = slug ? _.kebabCase(slug) : '';
  }

  get blockDescription(): string | null {
    return this.block.description;
  }
  set blockDescription(value) {
    this.setBlockDescription(value);
  }

  onUserSlugChange(slug: string | null) {
    if (_.isEmpty(slug)) {
      this.userHasAlteredSlug = false;
      this.blockSlug = this.blockTitle;
    } else {
      this.userHasAlteredSlug = true;
    }
  }

  async updateBlock() {
    if (this.formIsValid()) {
      this.isSaving = true;
      await this.saveBlock();
      this.isSaving = false;
    }
  }

  onEditorBlur() {
    return (this.isEditorValid =
      this.editorContent !== '<p>&nbsp;</p>' && !!this.editorContent);
  }

  formIsValid(): boolean {
    return [
      (<HTMLFormElement>this.$refs.title).validate(true),
      this.onEditorBlur(),
      (<HTMLFormElement>this.$refs.slug).validate(true),
      (<HTMLFormElement>this.$refs.description).validate(true),
    ].every(v => v);
  }

  async beforeRouteEnter(
    to: Route,
    from: Route,
    next: Function,
  ): Promise<void> {
    if (to.params.hasOwnProperty('id')) {
      await store.dispatch('blockEditor/getBlock', to.params.id);
    } else {
      await store.commit('blockEditor/resetBlockEditor');
    }
    next();
  }

  async beforeRouteUpdate(
    to: Route,
    from: Route,
    next: Function,
  ): Promise<void> {
    if (to.params.hasOwnProperty('id')) {
      await store.dispatch('blockEditor/getBlock', to.params.id);
    } else {
      await store.commit('blockEditor/getBlock');
    }
    next();
  }

  @Watch('block.id')
  onBlockIdChanged(id?: string, oldId?: string) {
    if (id && oldId === undefined) {
      this.$router.replace({ name: 'edit-block', params: { id } });
    }
  }
}
